<template>
  <div class="select-bank-card-popup">
    <van-popup v-model="showPopup" round position="bottom" height="520px">
      <div class="select-bank-card-popup-content">
        <div class="title">
          <div class="title-left" @click="hidePopup">
            <img src="@/assets/style/left-pupot.png" alt="" />
          </div>
          <span class="title-text">选择银行卡</span>
          <div class="add-bank-card" @click="handleAddBankCardClick">
            + 添加银行卡
          </div>
        </div>
        <div class="bank-card-list-box">
          <van-radio-group
            v-model="radio"
            class="radio-group"
          >
            <div v-for="item in bankList" :key="item.bankCardId" class="bank-card-list-wrap" :class="{'active': radio == item.id}">
              <BankCardList
                ref="bankCardListRef"
                :bankCard="item"
                @change="handleChange"
              />
            </div>
          </van-radio-group>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import BankCardList from "@/components/loan/bankCardList.vue";
import { getBankCardList, updateBorrowOrder } from "@/api/index.js";
export default {
  name: "SelectBankCardPopup",
  components: {
    BankCardList,
  },
  data() {
    return {
      showPopup: false,
      radio: "",
      bankList: [],
    };
  },
  async activated() {
    this.getBankCardList();
  },
  methods: {
    // 获取银行卡列表
    getBankCardList() {
      getBankCardList({ pageNumber: 1, pageSize: 100 }).then(
        (res) => {
          if (res.code === 2000) {
            this.bankList = res.data.recordList;
          }
        },
      );
    },
    handleChange(bankCard) {
      this.radio = bankCard.id || "";
      this.$store.state.orderDetails.repaymentBankId = bankCard.id || "";
      this.$store.commit("setOrderDetails", {
        ...this.$store.getters.orderDetails,
        repaymentBankNumber: bankCard.bankNumber,
        repaymentBankName: bankCard.bankName,
       });
      let params = {
        borrowOrderId: this.$store.getters.orderDetails.borrowOrderId,
        accountBankCardId: bankCard.id,
      }
      this.updateBorrowOrder(params);
      this.hidePopup();
    },
    // 更新借贷订单
    updateBorrowOrder(params) {
      updateBorrowOrder(params).then(
        (res) => {
          if (res.code === 2000) {
            this.$toast("银行卡更换成功");
          }
        },
      );
    },
    handleAddBankCardClick() {
      this.$store.commit("setBankCardBindingFlag", '2');
      this.$router.push({
        name: "bankCardBinding",
      });
    },
    init() {
      this.radio = this.$store.state.orderDetails?.repaymentBankId || "";
      this.showPopup = true;
    },
    hidePopup() {
      this.showPopup = false;
    },
  },
};
</script>

<style scoped lang="scss">
.select-bank-card-popup {
  .select-bank-card-popup-content {
    padding: 16px;
    min-height: 520px;
    max-height: 520px;
    overflow: auto;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 18px;
      color: #333333;
      position: relative;
      height: 40px;
      .title-left {
        display: flex;
        align-items: center;
        width: 50px;
        position: absolute;
        left: 0;
        display: flex;
        align-items: center;
        img {
          height: 16px;
        }
      }
      .title-text {
        flex: 1;
        text-align: center;
      }
      .add-bank-card {
        position: absolute;
        right: 0;
        font-size: 13px;
        color: #1d70f7;
        height: 30px;
        border-radius: 44px;
        border: 1px solid #1d70f7;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 6px;
      }
    
    }
    .bank-card-list-box{
      max-height: 480px;
      overflow: auto;
    }
  }
}
.bank-card-list-wrap{
  margin-top: 16px;
}
.active{
  border: 2px solid #1d70f7;
  border-radius: 12px;
}
</style>
